import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { MODULE_NAME as LANDING_PAGES_REPORTS } from 'modules/landing-pages/config/routes';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import { LANDING_PAGES_REPORT_ID } from './landingPagesReportId';
import { customColumns, defaultColumns } from './reportPresets';

export const landingPagesReportsReportConfig = {
    id: LANDING_PAGES_REPORT_ID,
    label: 'Landing Pages',
    module: LANDING_PAGES_REPORTS,
    endpoint: accountId => `/${accountId}/landing-pages`,
    rowIdField: FIELDS.ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    disableExport: true,
    disableForceFetch: false,
};

export default landingPagesReportsReportConfig;
